import httpApiApplication from '../../../http/httpApiApplication';

import { type FormVersionModel, type IdValue } from './types';

export const baseUrl = '/FormVersion';

export function updateFormVersion(id: string, request: FormVersionModel) {
  return httpApiApplication.put(`${baseUrl}/${id}`, request);
}

export function deleteFormVersion(id: string) {
  return httpApiApplication.delete(`${baseUrl}/${id}`);
}

/**
 * Recupera la versión del formulario activa para
 * las condiciones recibidas
 *
 * @export
 * @param {string} taxId Identificador del impuesto
 * @param {number} year Año que se declara
 * @param {string} [periodicity] Información de la periodicidad elegida
 * @return {*}  {Promise<IdValue>}
 */
export function getFormVersion(
  taxId: string,
  year: number,
  periodicity?: string
): Promise<IdValue> {
  const periodicityHeader = periodicity ? '?headerPeriodicity=' + periodicity : '';

  return httpApiApplication.get<IdValue>(`${baseUrl}/last/${taxId}/${year}${periodicityHeader}`);
}

export const createFormVersion = (request: FormVersionModel) => {
  return httpApiApplication.post(baseUrl, request);
};
